module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_22-f89e7a6aa887205c8747080336ebe427.jpg";